<template>
  <div class="messagebox" v-show="toggleWindows">
    <div class="messagebox-header" @mousedown="startDrag">
      <span class="chat_name">
        <template v-if="isChatPageDataShow">
          <template v-if="(chatPageData.currentConsultingType===1&&chatPageData.tuwenConsultationStatus===1) || (chatPageData.currentConsultingType===2 && chatPageData.phoneConsultationStatus===1)">
            咨询中{{formatSeconds(expireTime,2)}}后结束
          </template>
          <template v-if="(chatPageData.currentConsultingType===1&&chatPageData.tuwenConsultationStatus===2) || (chatPageData.currentConsultingType===2 && chatPageData.phoneConsultationStatus===2)">
            咨询结束
          </template>
        </template>
      </span>
      <span class="chat_name center">{{activedKey[type].tbNickName}}</span>
      <a-dropdown>
        <a class="ant-dropdown-link user-ellipsis" href="#" @click="changeMenus">
          <a-icon type="ellipsis" />
        </a>
        <a-menu slot="overlay">
          <a-menu-item @click="menuClick('1')" v-if="isShowChatEnd">
            <a href="javascript:;">结束服务</a>
          </a-menu-item>
          <a-menu-item @click="menuClick('2')">
            <a href="javascript:;">关闭</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>

    <div class="messagebox-content" ref="msgContent">
      <div class="moreMsgs" v-if="loadText!='已无更多数据'" @click="loadMoreMsgs">{{ loadText }}</div>
      <div v-for="(item, i) in msgObj" :key="i" class="message-group" :ref="'msgItem'+item.mid" :style="{ float: item.bySelf ? 'right' : 'left' }">
        <div class="topTips" v-if="item.ext&&item.ext.MessageType==='CounselTag'">
          <span class="topTips-text">{{ item.msg }}</span>
        </div>
        <template v-else>
          <div class="topTips" v-if="!item.bySelf && item.ext&&item.ext.CounselTimesLeft=='3'&&item.ext.MessageType=='CounselChat'">
            <span class="topTips-text">本次图文咨询服务已开始, 有效时长为24小时</span>
          </div>
          <h4 v-if="!item.bySelf" style="text-align: left; margin: 0">{{ activedKey[type].tbNickName }}</h4>
          <h4 v-else style="text-align: right; margin: 0">{{myName}}</h4>
          <div class="CounselCompleteView" v-if="item.ext&&item.ext.MessageType==='CounselComplete'">
            <span class="text">{{ item.msg }}</span>
            <div class="bottom">
              <div class="button">未解决</div>
              <div class="button">已解决</div>
            </div>
          </div>
          <a-dropdown v-else :trigger="['contextmenu']" :style="{ float: item.bySelf ? 'right' : 'left' }" :disabled="item.status == 'recall'">
            <span style="user-select: none">
              <!-- 图片消息 -->
              <img :key="item.msg" :src="item.msg ? item.msg : ''" v-if="item.type === 'img'" class="img-style" />
              <!-- 文件card -->
              <div v-else-if="item.type === 'file'" class="file-style" :style="{ float: item.bySelf ? 'right' : 'left' }">
                <a-card :body-style="{ padding: '0px' }">
                  <div style="padding: 14px">
                    <h2>文件</h2>
                    <span>
                      <h3>{{ item.filename }}</h3>
                    </span>
                    <div class="bottom clearfix">
                      <span>{{ readablizeBytes(item.file_length) }}</span>
                      <a :href="item.msg" :download="item.filename">点击下载</a>
                    </div>
                  </div>
                </a-card>
              </div>
              <!-- 音频消息 -->
              <div v-else-if="item.type === 'audio'" :style="{ float: item.bySelf ? 'right' : 'left' }">
                <audio :src="item.msg" controls></audio>
              </div>
              <!-- 视频消息 -->
              <div v-else-if="item.type === 'video'">
                <video :src="item.msg" width="100%" controls></video>
              </div>
              <!-- 聊天消息 -->
              <p style="user-select: text" v-else v-html="renderTxt(item.msg)" :class="{ byself: item.bySelf }" />
              <!-- <div v-if="item.bySelf?true:false" class="status">{{status[item.status]}}</div> -->
            </span>
          </a-dropdown>
          <!-- 聊天时间 -->
          <div v-if="item.status !== 'recall'" class="time-style" :style="{ 'text-align': item.bySelf ? 'right' : 'left' }">
            {{ renderTime(item.time) }}
            <!-- {{ item.bySelf ? status[item.status] : "" }} -->
          </div>

          <div class="topTips" v-if="!item.bySelf && item.ext&&item.ext.MessageType=='CounselChat' && item.ext.CounselTimesLeft>=0">
            <span class="topTips-text">{{`用户还有${item.ext.CounselTimesLeft}次追问机会`}}</span>
          </div>
          <div class="topTips" v-if="!item.bySelf && item.ext&&item.ext.MessageType=='CounselCompleted'">
            <span class="topTips-text">本次咨询服务结束</span>
          </div>
        </template>

      </div>
    </div>
    <div class="messagebox-footer">
      <div class="footer-icon">
        <!-- 表情组件 -->
        <ChatEmoji v-on:selectEmoji="selectEmoji" :inpMessage="message" />
        <!-- 上传图片组件 -->
        <UpLoadImage :type="this.type" :chatId="activedKey[type]" />
        <!-- 上传文件组件 -->
        <!-- <UpLoadFile :type="this.type" :chatId="activedKey[type]" /> -->
        <!-- 历史记录 -->
        <SearchModal v-if="this.type !== 'chatroom'" :type="this.type" :chatId="activedKey[type]" />
        <!-- 发送语音 -->
        <RecordAudio :type="this.type" :chatId="activedKey[type]" />
      </div>
      <!-- 文字输入框 -->
      <div class="fotter-send">
        <a-input v-model="message" equired placeholder="消息" class="sengTxt" @pressEnter="onSendTextMsg" style="resize: none" ref="txtDom" />
        <el-button :class="message === '' ? 'no_content_send_btn' : 'chat_send_btn'" type="primary" @click="onSendTextMsg">发送</el-button>
      </div>
    </div>
    <GetGroupInfo ref="groupInfoModel" @closeGroupMessage="closeGroupMessage" />
    <DisturbConfig ref="disturbConfigModel" :userId="this.userId" />

    <!-- fix 移动到全局 -->
    <!-- <AddAVMemberModal ref="addAvMembertModal" :to="activedKey[type]" @start="start_multi"/> -->
    <!-- <EmediaModal ref="emediaModal" @changeIsVideoState="changeIsVideoState" /> -->
    <!-- <MultiAVModal :to="activedKey[type]" /> -->
  </div>
</template>

<script>
import ChatEmoji from '../chatEmoji/index.vue';
import emoji from '@/config/emoji';
import UpLoadImage from '../upLoadImage/index.vue';
import UpLoadFile from '../upLoadFile/index.vue';
import RecordAudio from '../recorder/index.vue';
import './index.less';
import { mapActions, mapGetters, mapState } from 'vuex';

import moment from 'moment';
import _ from 'lodash';
// import MultiAVModal from "../emediaModal/multiAVModal";
// import EmediaModal from "../emediaModal/index";
import GetGroupInfo from '../group/groupInfo.vue';
import DisturbConfig from '../pushConfig/index.vue'
import SearchModal from '../search/index.vue'
import { readablizeBytes, renderTime } from '@/utils/index'
export default {
  data () {
    return {
      timer: null,
      expireTime: 0,
      topMid: '',
      activedKey: {
        contact: '',
        group: '',
        chatroom: '',
      },
      message: '',
      isHttps: window.location.protocol === 'https:',
      loadText: '',
      status: {
        sending: '发送中',
        sent: '已发送',
        read: '已读',
      },
      nowIsVideo: false,
      titleObj: {
        titleMode: 'time',
        timeStamp: 10
      },
      msgObj: {}, // 聊天窗口渲染数据的变量
      routeNewOldObj: null, // 保存路由信息的变量
      msgNewOldObj: null, // 保存聊天信息的变量
      flagObj: { // 触发聊天信息更新的变量
        msgFlag: false,
        routeFlag: false
      },
      typeId: {
        group: '',
        contact: '',
        chatroom: ''
      },
      globalHistoryMsg: {},
      conversationId: '',
      userId: '',
      myName: '',
      readablizeBytes,
      renderTime
    };
  },
  beforeMount () {
    // if(this.type === 'contact'){
    // 	this.onGetContactUserList();
    // }
    // else if(this.type === 'group'){
    // 	this.onGetGroupUserList();
    // }
    // else if(this.type === 'chatroom'){
    // 	this.onGetChatroomUserList();
    // }
    this.userId = JSON.parse(localStorage.getItem('userInfo')).userId
  },
  mounted () {
    const name = window.sessionStorage.getItem('name')
    this.myName = `${name}`

  },
  watch: {
    loadText: {
      handler (msgNewVal, msgOldVal) {
        console.log(msgNewVal)
        console.log(msgOldVal)
      },
      deep: true
    },
    curMsgList: {
      handler (msgNewVal, msgOldVal) {
        const id = this.currentConversationId
        if (!msgOldVal) {
          if (msgNewVal && Object.keys(msgNewVal).length) {
            // eslint-disable-next-line guard-for-in
            for (let item in msgNewVal) {
              if (msgNewVal[item].chatId === id) {
                if (Object.keys(this.msgObj).length) {
                  if (Object.values(this.msgObj).findIndex(val => Number(val.time) === Number(msgNewVal[item].time)) === -1) {
                    this.globalHistoryMsg[this.conversationId].push(msgNewVal[item])
                  }
                }
                else {
                  this.globalHistoryMsg[this.conversationId].push(msgNewVal[item])
                }
              }
            }
          }
        }
        else if (!msgNewVal) {
          if (this.conversationId) {
            if (msgOldVal && Object.keys(msgOldVal).length) {
              // eslint-disable-next-line guard-for-in
              for (let item in msgOldVal) {
                if (msgOldVal[item].chatId === id) {
                  if (Object.keys(this.msgObj).length) {
                    if (Object.values(this.msgObj).findIndex(val => Number(val.time) === Number(msgOldVal[item].time)) === -1) {
                      this.globalHistoryMsg[this.conversationId].push(msgOldVal[item])
                    }
                  }
                  else {
                    this.globalHistoryMsg[this.conversationId].push(msgOldVal[item])
                  }
                }
              }
            }
          }
        }
        else if (msgNewVal && msgOldVal) {
          if (Object.keys(msgNewVal).length > Object.keys(msgOldVal).length) {
            if (new Date().getTime() - msgNewVal[Object.keys(msgNewVal).length - 1].time > 2000) {
              const tempArr = []
              // eslint-disable-next-line guard-for-in
              for (let item in msgNewVal) {
                if (msgNewVal[item].chatId === id) {
                  if (Object.keys(this.msgObj).length) {
                    if (Object.values(this.msgObj).findIndex(val => Number(val.time) === Number(msgNewVal[item].time)) === -1) {
                      tempArr.push(msgNewVal[item])
                    }
                  }
                  else {
                    tempArr.push(msgNewVal[item])
                  }
                }
              }
              this.globalHistoryMsg[this.conversationId] = [...tempArr, ...this.globalHistoryMsg[this.conversationId]]
            }
            else {
              this.globalHistoryMsg[this.conversationId] && this.globalHistoryMsg[this.conversationId].push(msgNewVal[Object.keys(msgNewVal).length - 1])
            }
          }
          else {
            // eslint-disable-next-line guard-for-in
            for (let item in msgOldVal) {
              if (msgOldVal[item].chatId === id) {
                if (Object.keys(this.msgObj).length) {
                  if (Object.values(this.msgObj).findIndex(val => Number(val.time) === Number(msgOldVal[item].time)) === -1) {
                    this.globalHistoryMsg[this.conversationId].push(msgOldVal[item])
                  }
                }
                else {
                  this.globalHistoryMsg[this.conversationId].push(msgOldVal[item])
                }
              }
            }
            // eslint-disable-next-line guard-for-in
            for (let item in msgNewVal) {
              if (msgNewVal[item].chatId === id) {
                if (Object.keys(this.msgObj).length) {
                  if (Object.values(this.msgObj).findIndex(val => Number(val.time) === Number(msgNewVal[item].time)) === -1) {
                    this.globalHistoryMsg[this.conversationId].push(msgNewVal[item])
                  }
                }
                else {
                  this.globalHistoryMsg[this.conversationId].push(msgNewVal[item])
                }
              }
            }
          }
        }
        if (this.conversationId && this.globalHistoryMsg[this.conversationId].length) {
          const tempObj = {}
          let num = 0
          this.globalHistoryMsg[this.conversationId].sort((a, b) => {
            return a.time - b.time
          })
          this.globalHistoryMsg[this.conversationId].forEach((item, index) => {
            if (item.from && item.from === this.userId) {
              item.bySelf = true
            }
            if (item.chatId === id) {
              if (Object.values(tempObj).length > 0 && Object.values(tempObj).findIndex(val => Number(val.time) === Number(item.time)) === -1) {
                num++
                tempObj[num] = item
              }
              else if (!Object.values(tempObj).length) {
                tempObj[num] = item
              }
            }
          })
          this.msgObj = tempObj
        }
        else {
          this.msgObj = {}
        }
        if (this.loadText != '已无更多数据' && id) {
          this.loadMoreMsgs()
        }
        this.scollBottom()
      },
      deep: true
    },
  },
  computed: {
    isShowChatEnd () {
      if (!this.chatPageData) {
        return false
      } else if (this.chatPageData.currentConsultingType === 1 && this.chatPageData.tuwenConsultationStatus === 1) {
        return true
      } else if (this.chatPageData.currentConsultingType === 2 && this.chatPageData.phoneConsultationStatus === 1) {
        return true
      } else {
        return false
      }
    },
    isChatPageDataShow () {
      if (!this.chatPageData) {
        return false
      } else if (this.chatPageData.currentConsultingType === 1) {
        return this.chatPageData.tuwenConsultationStatus === 1 || this.chatPageData.tuwenConsultationStatus === 2
      } else {
        return this.chatPageData.phoneConsultationStatus === 1 || this.chatPageData.phoneConsultationStatus === 2
      }
    },
    ...mapGetters({
      chatPageData: 'chatPageData',
      // contact: 'onGetContactUserList',
      group: 'onGetGroupUserList',
      // chatroom: 'onGetChatroomUserList',
      curMsgList: 'onGetCurrentChatObjMsg',
      currentConversationId: 'currentConversationId'
    }),
    // 控制聊天框
    toggleWindows () {
      let show
      switch (this.type) {
        case 'contact':
          show = this.activedKey[this.type] != ''
          break
        case 'group':
          show = !!this.group.find(item => item.groupid === this.activedKey[this.type].groupid)
          break
        default:
          show = this.activedKey[this.type] != ''
      }
      return show
    },
  },
  props: [
    'type', // 聊天类型 contact, group, chatroom
    'username', // 选中的聊天对象
    'broken', // 是否适应移动端
    'showUserList',
    'hideUserList',
  ],
  methods: {
    ...mapActions([
      'onGetContactUserList',
      'onGetGroupUserList',
      'onGetChatroomUserList',
      'onGetCurrentChatObjMsg',
      'onSendText',
      'onCallVideo',
      'onCallVoice',
      'getGroupMembers',
      'getHistoryMessage',
      'onAddBlack',
      'onDelteFirend',
      'onGetGroupinfo',
      'onGetGroupBlack',
      'onGetSilentConfig',
      'updateChatStatus'
    ]),
    getTime (time) {
      // 转换为时分秒
      let h = parseInt(time / 60 / 60 % 24)
      h = h < 10 ? '0' + h : h
      let m = parseInt(time / 60 % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(time % 60)
      s = s < 10 ? '0' + s : s
      // 作为返回值返回
      return `${h}:${m}:${s}`
    },
    startDrag (e) {
      this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.startDrag(e)
    },
    setReportMsgId (id) {
      this.$store.commit('setReportMsgId', { messageId: id });
    },
    getKey (item, type) {
      let key = '';
      switch (type) {
        case 'contact':
          key = item.name;
          break;
        case 'group':
          key = item.groupid;
          break;
        case 'chatroom':
          key = item.id;
          break;
        default:
          break;
      }
      return key;
    },
    getCurrentMsg (props) {
      this.onGetCurrentChatObjMsg({
        type: props,
        id: this.getKey(this.activedKey[props], props),
      });
    },
    expireTimeComputer () {
      if (this.expireTime > 0) {
        this.expireTime = this.expireTime - 1
      } else {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    select (key) {
      this.$store.dispatch('setChatPageData').then(res => {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
        if (res.currentConsultingType === 1) {
          if (res.tuwenConsultationStatus === 1 && res.tuwenConsultationDate > 0) {
            this.expireTime = res.tuwenConsultationDate
            this.timer = setInterval(this.expireTimeComputer, 1000)
          }
        } else {
          if (res.phoneConsultationStatus === 1 && res.phoneConsultationDate > 0) {
            this.expireTime = res.phoneConsultationDate
            this.timer = setInterval(this.expireTimeComputer, 1000)
          }
        }
      })
      switch (this.type) {
        case 'contact':
          this.conversationId = key.name
          break;
        case 'group':
          this.conversationId = key.groupid
          break;
        case 'chatroom':
          this.conversationId = key.id
          break;
        default:
          break;
      }
      if (!this.globalHistoryMsg[this.conversationId]) {
        this.globalHistoryMsg[this.conversationId] = []
      } else {
        const tempObj = {}
        this.globalHistoryMsg[this.conversationId].forEach((item, index) => {
          if (item.chatId === this.conversationId) {
            tempObj[index] = item
          }
        })
        this.msgObj = tempObj
      }
      this.$data.activedKey[this.type] = key;
      const me = this;
      me.$data.loadText = '加载更多';
      if (this.type === 'contact') {
        this.typeId.contact = key.name
        this.onGetCurrentChatObjMsg({ type: this.type, id: key.name });
        setTimeout(() => {
          this.$store.commit('updateMessageStatus', {
            action: 'oneUserReadMsgs',
            readUser: key.name,
          });
          this.$forceUpdate();
        }, 100);
        if (!this.curMsgList) {
          this.getHistoryMessage({ name: key.name, isGroup: false });
        }
      }
      this.$emit('changeActiveFlag', this.typeId)
    },

    loadMoreMsgs () {
      const me = this;
      const msgValues = Object.values(this.msgObj)
      this.topMid = msgValues.length ? msgValues[0].mid : ''
      if (this.loadText === '已无更多数据') {
        this.scollBottom()
      }
      const success = function (msgs) {
        if (msgs.length === 0) {
          me.$data.loadText = '已无更多数据';
        }
      };
      let name = '';
      let isGroup = false;
      if (this.type === 'contact') {
        name = this.$data.activedKey[this.type].name;
      }
      else if (this.type === 'group') {
        name = this.$data.activedKey[this.type].groupid;
        isGroup = true;
      }
      else if (this.type === 'chatroom') {
        name = this.$data.activedKey[this.type].id;
        isGroup = true;
      }
      this.getHistoryMessage({
        name,
        isGroup,
        success,
      });

    },

    changeMenus () {
      if (this.type === 'contact') {
      }
      else if (this.type === 'group') {
        this.$refs.groupInfoModel.chengeInfoModel();
        this.getGroupInfo();
      }
    },
    menuClick (i) {
      this.changeMenus();
      switch (i) {
        case '1':
          this.msgboxMixin(() => {
            this.onSendText({
              chatType: this.type,
              chatId: this.$data.activedKey[this.type],
              message: '您好，本次咨询是否已帮你解决所有问题？是否结束服务？',
              tbNickName: this.myName,
              tbPic: this.chatPageData.tbDoctorPic || this.getDoctorImg(),
              createTime: new Date().getTime(),
              messageType: 'CounselComplete'
            });
          }, '确定结束当前咨询服务？')
          break;
        case '2':
          this.$store.commit('SET_CHAT_SHOW', false)
          break;
        default:
          break;
      }
    },
    getGroupInfo () {
      this.onGetGroupinfo({
        select_id: this.$data.activedKey[this.type].groupid,
      });
    },
    onSendTextMsg () {
      if (this.$data.message == '' || this.$data.message == '\n') {
        this.$data.message = '';
        return;
      }
      this.onSendText({
        chatType: this.type,
        chatId: this.$data.activedKey[this.type],
        message: this.$data.message,
      });
      this.$data.message = '';
    },

    selectEmoji (v) {
      this.$data.message = v;
      this.$refs.txtDom.focus();
    },

    customEmoji (value) {
      return `<img src="${require(`@/assets/static/faces/${value}`)}" style="width:20px"/>`
    },

    renderTxt (txt = '') {
      let rnTxt = [];
      let match = null;
      const regex = /(\[.*?\])/g;
      let start = 0;
      let index = 0;
      while ((match = regex.exec(txt))) {
        index = match.index;
        if (index > start) {
          rnTxt.push(txt.substring(start, index));
        }
        if (match[1] in emoji.obj) {
          const v = emoji.obj[match[1]];
          rnTxt.push(this.customEmoji(v));
        }
        else {
          rnTxt.push(match[1]);
        }
        start = index + match[1].length;
      }
      rnTxt.push(txt.substring(start, txt.length));
      return rnTxt.toString().replace(/data:[^;]+;base64,[^,]*|,/g, (match) =>
        match.startsWith("data:") ? match : ""
      );
    },

    callVideo () {
      if (this.type == 'contact') {
        const val = this.$data.activedKey[this.type].name;
        this.$emit('EmediaModalFun', [val], 1);
      }
      else if (this.type == 'group') {
        this.getGroupMembers(this.$data.activedKey[this.type].groupid);
        let _this = this;
        this.$emit('show_add_member_modal', this.type);
      }
    },
    callVoice () {
      const val = this.$data.activedKey[this.type].name;
      this.$emit('EmediaModalFun', [val], 0);
    },

    getLastMsg (item) {
      // const { name, params } = this.$route;
      const name = 'contact'
      const chatList = this.$store.state.chat.msgList[name];
      let userId = '';
      if (name == 'contact') {
        userId = item.name;
      }
      else if (name == 'group') {
        userId = item.groupid;
      }
      else {
        userId = item.id;
      }
      const currentMsgs = chatList[userId] || [];
      const lastMsg = currentMsgs.length
        ? currentMsgs[currentMsgs.length - 1].msg
        : '';
      const msgTime = currentMsgs.length
        ? this.renderTime(currentMsgs[currentMsgs.length - 1].time)
        : '';
      return { lastMsg, msgTime };
    },
    scollBottom () {
      setTimeout(() => {
        const dom = this.$refs.msgContent;
        if (!dom) return;
        dom.scrollTop = dom.scrollHeight;
      }, 0);
    },
    closeGroupMessage () {
      // 退出群组或解散群组时关闭聊天框
      this.$data.activedKey.group = '';
      this.$emit('chatTypeChange', { key: 'group' })
    },
    closeContactMessage () {
      // 删除好友时关闭当前聊天框
      this.$data.activedKey.contact = '';
      this.$emit('chatTypeChange', { key: 'contact' })
    },
    // changeIsVideoState(v) {
    //   v ? (this.$data.nowIsVideo = true) : (this.$data.nowIsVideo = false);
    // }
  },
  components: {
    ChatEmoji,
    UpLoadImage,
    UpLoadFile,
    GetGroupInfo,
    RecordAudio,
    // AddAVMemberModal,
    // MultiAVModal,
    // EmediaModal,
    DisturbConfig,
    SearchModal
  }
};
</script>

<style scoped lang="less">
.topTips {
  padding-top: 15px;
  margin-bottom: 15px;
  text-align: center;
}
.topTips .topTips-text {
  border-radius: 10px;
  display: inline-block;
  padding: 7px 10px 7px 10px;
  font-size: 12px;
  color: #c1c9e4;
  background: #e5e9f8;
}

.CounselCompleteView {
  font-size: 14px;
  box-sizing: border-box;
  padding: 13px 9px 12px 14px;
  border-radius: 13px;
  width: 266px;
  height: 120px;
  background: #dff3ff;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
}

.CounselCompleteView .text {
  font-size: 14px;
  text-align: left;
}
.CounselCompleteView.close {
  background: #ffffff;
}
.CounselCompleteView.close .bottom .button {
  background: #e1e1e1;
}
.CounselCompleteView .bottom {
  padding: 0 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.CounselCompleteView .bottom .button {
  width: 100px;
  height: 30px;
  background: #69c2ff;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #ffffff;
}

.byself {
  float: right;
}

.recallMsg {
  font-size: 12px;
  color: #aaa;
  width: 100%;
  text-align: center;
}
.custom-title {
  font-weight: 500;
}
.moreMsgs {
  width: 200px;
  height: 30px;
  border-radius: 20px;
  margin: 0 auto;
  background: rgba(114, 112, 112, 0.143);
  font-size: 13px;
  letter-spacing: 0.5px;
  cursor: pointer;
  line-height: 30px;
}
.status {
  display: inline;
  position: relative;
  top: 20px;
  font-size: 12px;
  left: -6px;
  color: #736c6c;
  float: left;
}
.unreadNum {
  float: left;
  width: 100%;
}
.icon-style {
  display: inline-block;
  background-color: #f04134;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: white;
  line-height: 1.5;
  text-align: center;
}
.emoji-style {
  width: 22px;
  float: left;
}
.img-style {
  max-width: 350px;
}
.time-style {
  clear: both;
  margin-left: 2px;
  margin-top: 3px;
  font-size: 12px;
  color: #888c98;
}
.file-style {
  width: 240px;
  margin: 2px 2px 2px 0;
  font-size: 13px;
  h2 {
    border-bottom: 1px solid #e0e0e0;
    font-weight: 300;
    text-align: left;
  }
  h3 {
    max-width: 100%;
    font-size: 15px;
    height: 20px;
    line-height: 20px;
    font-weight: 600;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    margin-bottom: 20px;
  }
  .bottom {
    span {
      color: #999999;
      text-align: left;
    }
  }
  a {
    color: #999999;
    float: right;
    text-decoration: none;
  }
}
</style>
